import { formatDurationLabel } from "@clipboard-health/date-time";
import { Text, type TextProps } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { type Theme } from "@mui/material";

interface SentHomeChargesTextProps extends Omit<TextProps, "color"> {
  sentHomeChargeHours: number;
  color?: (theme: Theme) => string | undefined;
}

export function SentHomeChargesText(props: SentHomeChargesTextProps) {
  const { sentHomeChargeHours, variant = "body2", color: propsColor, ...textProps } = props;

  const hoursText =
    sentHomeChargeHours > 0 &&
    formatDurationLabel(sentHomeChargeHours, "hour", { keepOriginalUnit: true });

  return (
    <Text
      variant={variant}
      color={(theme) => {
        if (isDefined(propsColor)) {
          return propsColor(theme);
        }

        return theme.palette.text.secondary;
      }}
      {...textProps}
    >
      {sentHomeChargeHours > 0 ? (
        <>
          If the workplace cancels the shift after you&apos;ve already arrived, you&apos;ll be paid{" "}
          <strong>{hoursText}</strong> at the scheduled rate.
        </>
      ) : (
        <>
          If the workplace cancels the shift after you&apos;ve already arrived, you&apos;ll only be
          paid for any time worked.
        </>
      )}
    </Text>
  );
}
